import { render, staticRenderFns } from "./IconManagement.vue?vue&type=template&id=c450569a"
import script from "./IconManagement.vue?vue&type=script&lang=js"
export * from "./IconManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports